// import Constants from '@/utils/Constants'

export default class ApiManager {
  /**
   * apiClientsを介してAPIリクエストをまとめて行う
   * @param {Array} types APIのタイプの配列
   * @param {Array} methods APIのメソッド名の配列
   * @param {Array} parameters APIのパスパラメータ・クエリパラメータの配列
   */
  static request (types, methods, parameters) {
    let promises = []
    let apiClients = {
      auth: window._API_.Authorization(),
      // ダッシュボード
      dashboard: window._API_.Dashboard(),
      adminNotice: window._API_.AdminNotice(),
      // サービス管理
      service: window._API_.Service(),
      serviceDeliveryType: window._API_.ServiceDeliveryType(),
      serviceAttributeType: window._API_.ServiceAttributeType(),
      serviceFunction: window._API_.ServiceFunction(),
      serviceMailMagazine: window._API_.ServiceMailMagazine(),
      serviceLinkedCms: window._API_.ServiceLinkedCms(),
      serviceRss: window._API_.ServiceRss(),
      serviceDropbox: window._API_.ServiceDropbox(),
      serviceContentsSetting: window._API_.ServiceContentsSetting(),
      serviceContentsApply: window._API_.ServiceContentsApply(),
      serviceLinkCategory: window._API_.ServiceLinkCategory(),
      // ファイル管理
      file: window._API_.File(),
      // ボット管理
      bot: window._API_.Bot(),
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
      // 外部パートナー連携管理
      partner: window._API_.Partner(),
      // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED
      // マスタ管理
      deliveryTypeMst: window._API_.DeliveryTypeMst(),
      noticeTypeMst: window._API_.NoticeTypeMst(),
      linkedCmsMst: window._API_.LinkedCmsMst(),
      screenConfigMst: window._API_.ScreenConfigMst(),
      screenIdMst: window._API_.ScreenIdMst(),
      spAppMst: window._API_.SpAppMst(),
      // アカウント管理
      user: window._API_.User(),
      // お知らせ管理
      notice: window._API_.Notice(),
      noticeBot: window._API_.NoticeBot(),
      // ログ管理
      log: window._API_.Log(),
      // ADMP管理
      tenant: window._API_.Tenant(),
      community: window._API_.Community(),
      device: window._API_.Device(),
      // ささえiでんわ管理
      videoChat: window._API_.VideoChat(),
      // ロケーション管理
      location: window._API_.Location(),
      // ユーティリティ
      const: window._API_.Const(),
      util: window._API_.Util()
    }
    for (let i = 0; i < methods.length; i++) {
      let method = window._API_.mode === 'stub' ? 'stub' + methods[i] : methods[i]

      // APIが存在している時
      if (apiClients[types[i]] && apiClients[types[i]][method]) {
        promises.push(apiClients[types[i]][method](parameters[i]))

      // APIが存在しないのでモックデータを利用する時
      } else {
        // console.log(method)
        
        // -----------
        // Authorization
        // -----------

        // stubv1Login
        if (method === 'stubv1Login') {
          if (parameters[i].loginId === 'admin') {
            promises.push(this.requestMock('stubv1LoginAdmin'))
          } else if (parameters[i].loginId === 'operator') {
            promises.push(this.requestMock('stubv1LoginOperator'))
          } else if (parameters[i].loginId === 'setup') {
            promises.push(this.requestMock('stubv1LoginSetup'))
          } else {
            promises.push(this.requestMock('stubv1LoginOperator'))
          }
        
        // -----------
        // User
        // -----------

        // // stubv1UserDetailGet
        // } else if (method === 'stubv1UserDetailGet') {
        //   if (parameters[i].userUuid) {
        //     promises.push(this.requestMock('stubv1UserDetailGet_' + parameters[i].userUuid))
        //   } else {
        //     promises.push(this.requestMock(method))
        //   }
        
        // -----------
        // AdminNotice
        // -----------

        // stubv1AdminNoticeDetailGet
        } else if (method === 'stubv1AdminNoticeDetailGet') {
          if (parameters[i].adminNoticeUuid) {
            promises.push(this.requestMock('stubv1AdminNoticeDetailGet_' + parameters[i].adminNoticeUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service
        // -----------

        // stubv1ServiceDetailGet
        } else if (method === 'stubv1ServiceDetailGet') {
          if (parameters[i].serviceUuid) {
            promises.push(this.requestMock('stubv1ServiceDetailGet_' + parameters[i].serviceUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service : DeliveryType
        // -----------

        // stubv1ServiceDeliveryTypeDetailGet
        } else if (method === 'stubv1ServiceDeliveryTypeDetailGet') {
          if (parameters[i].serviceDeliveryTypeUuid) {
            promises.push(this.requestMock('stubv1ServiceDeliveryTypeDetailGet_' + parameters[i].serviceDeliveryTypeUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service : AttributeType
        // -----------

        // stubv1ServiceAttributeTypeDetailGet
        } else if (method === 'stubv1ServiceAttributeTypeDetailGet') {
          if (parameters[i].attributeTypeUuid) {
            promises.push(this.requestMock('stubv1ServiceAttributeTypeDetailGet_' + parameters[i].attributeTypeUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service : Function
        // -----------

        // stubv1ServiceFunctionDetailGet
        } else if (method === 'stubv1ServiceFunctionDetailGet') {
          if (parameters[i].serviceFunctionUuid) {
            promises.push(this.requestMock('stubv1ServiceFunctionDetailGet_' + parameters[i].serviceFunctionUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service : MailMagazine
        // -----------

        // stubv1ServiceMailMagazineDetailGet
        } else if (method === 'stubv1ServiceMailMagazineDetailGet') {
          if (parameters[i].serviceMailMagazineUuid) {
            promises.push(this.requestMock('stubv1ServiceMailMagazineDetailGet_' + parameters[i].serviceMailMagazineUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Service : ContentsSetting
        // -----------

        // stubv1ServiceContentsSettingDetailGet
        } else if (method === 'stubv1ServiceContentsSettingDetailGet') {
          if (parameters[i].serviceContentsUuid) {
            promises.push(this.requestMock('stubv1ServiceContentsSettingDetailGet_' + parameters[i].serviceContentsUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // File
        // -----------

        // stubv1FileListGet
        } else if (method === 'stubv1FileListGet') {
          if (parameters[i].contentType) {
            promises.push(this.requestMock('stubv1FileListGet_' + parameters[i].contentType))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Masta
        // -----------

        // stubv1ScreenConfigMstLayoutGet
        } else if (method === 'stubv1ScreenConfigMstLayoutGet') {
          if (parameters[i].screenConfigMstUuid) {
            promises.push(this.requestMock('stubv1ScreenConfigMstLayoutGet_' + parameters[i].screenConfigMstUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Notice
        // -----------

        // stubv1NoticeListGet
        } else if (method === 'stubv1NoticeListGet') {
          if (parameters[i].filters.listType) {
            promises.push(this.requestMock('stubv1NoticeListGet_' + parameters[i].filters.listType))
          } else {
            promises.push(this.requestMock(method))
          }

        // stubv1NoticeDeliveryDetailGet
        } else if (method === 'stubv1NoticeDeliveryDetailGet') {
          if (parameters[i].noticeDeliveryUuid) {
            promises.push(this.requestMock('stubv1NoticeDeliveryDetailGet_' + parameters[i].noticeDeliveryUuid))
          } else {
            promises.push(this.requestMock(method))
          }

        // stubv1NoticeDetailGet
        } else if (method === 'stubv1NoticeDetailGet') {
          if (parameters[i].noticeUuid) {
            promises.push(this.requestMock('stubv1NoticeDetailGet_' + parameters[i].noticeUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Log
        // -----------

        // stubv1LogResponseGet
        } else if (method === 'stubv1LogResponseGet') {
          if (parameters[i].functionAnswerUuid) {
            promises.push(this.requestMock('stubv1LogResponseGet_' + parameters[i].functionAnswerUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Tenant
        // -----------

        // stubv1TenantDetailGet
        } else if (method === 'stubv1TenantDetailGet') {
          if (parameters[i].tenantUuid) {
            promises.push(this.requestMock('stubv1TenantDetailGet_' + parameters[i].tenantUuid))
          } else {
            promises.push(this.requestMock(method))
          }
        
        // -----------
        // Community
        // -----------

        // stubv1CommunityDetailGet
        } else if (method === 'stubv1CommunityDetailGet') {
          if (parameters[i].communityUuid) {
            promises.push(this.requestMock('stubv1CommunityDetailGet_' + parameters[i].communityUuid))
          } else {
            promises.push(this.requestMock(method))
          }

        } else {
          promises.push(this.requestMock(method))
        }
      }
    }
    return Promise.all(promises.map(p => p.catch((error) => error.response)))
  }

  /**
   * モックデータを取得する
   * @param {String} fileName モックデータを取得するファイル名
   */
  static requestMock (fileName) {
    let data = require('../../tests/mock/' + fileName).default.mock
    return new Promise(function (resolve) {
      setTimeout(resolve(data), 2000)
    })
  }
}
